import {
  canViewDashboardInsights,
  canViewPerformInsights,
  canViewPerformAdmin,
  canViewLearnInsights,
  canViewEngagementInsights,
  canViewTalentReview,
} from '@get-bridge/learn-legacy-shared/dist/utils/canViewPermissions';
import isFeatureEnabled from '@get-bridge/learn-legacy-shared/dist/utils/isFeatureEnabled';

const insights = (hosts, user, insightsOnRuntime) => {
  const performAdmin = canViewPerformAdmin(user);
  return [
    hosts.perform && canViewDashboardInsights(user) && {
      id: 'SECONDARY_INSIGHTS_OVERVIEW',
      host: hosts.perform,
      href: '/talent/insights',
      name: I18n.t('Overview'),
    },
    hosts.perform && canViewPerformInsights(user) && {
      id: 'SECONDARY_INSIGHTS_1ON1_CADENCE',
      host: hosts.perform,
      href: '/talent/insights/frequency',
      name: I18n.t('1on1 Cadence'),
    },
    hosts.perform && performAdmin && {
      id: 'SECONDARY_INSIGHTS_SKILL_MASTERY',
      host: hosts.perform,
      href: '/talent/insights/mastery',
      name: I18n.t('Skill Mastery'),
    },
    hosts.perform && performAdmin && {
      id: 'SECONDARY_INSIGHTS_GOAL_PERFORMANCE',
      host: hosts.perform,
      href: '/talent/insights/goals',
      name: I18n.t('Goal Performance'),
      okrName: I18n.t('Objective Performance'),
    },
    !isFeatureEnabled('learn_insights_retirement') && insightsOnRuntime && hosts.perform && canViewLearnInsights(user) && {
      id: 'SECONDARY_INSIGHTS_LEARNING',
      host: hosts.perform,
      href: '/insights',
      name: I18n.t('Learning'),
    },
    !isFeatureEnabled('learn_insights_retirement') && !insightsOnRuntime && hosts.learn && canViewLearnInsights(user) && {
      id: 'SECONDARY_INSIGHTS_LEARNING',
      host: hosts.learn,
      href: '/insights',
      name: I18n.t('Learning'),
    },
    hosts.perform && canViewEngagementInsights(user) && {
      id: 'SECONDARY_INSIGHTS_ENGAGEMENT',
      host: hosts.perform,
      href: '/engage',
      name: I18n.t('Engagement Surveys'),
    },
    hosts.perform && canViewTalentReview(user) && {
      id: 'SECONDARY_INSIGHTS_TALENT_REVIEW',
      host: hosts.perform,
      href: '/talent/insights/talent-review',
      name: I18n.t('Talent Review'),
    },
    hosts.perform && performAdmin && {
      id: 'SECONDARY_INSIGHTS_PERFORMANCE_CONVERSATION',
      host: hosts.perform,
      href: '/talent/insights/performance-conversation',
      name: I18n.t('Performance Conversations'),
    },
  ].filter(Boolean);
};

export default insights;



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/utils/buildAtlasLinks/primaryLinks/insights.js